// Formatowanie kwoty „na żywo" (podczas wpisywania): separator tysięcy = spacja,
// separator dziesiętny = przecinek, maks. 2 miejsca po przecinku. Zwraca też
// wartość znormalizowaną (stored) z kropką dziesiętną do dalszych obliczeń.
export const formatLive = (raw: string): { display: string; stored: string } => {
  const s = raw.replace(/[^\d.,]/g, "");
  const sepIdx = s.search(/[.,]/);
  let intPart = sepIdx >= 0 ? s.slice(0, sepIdx) : s;
  const decPart =
    sepIdx >= 0 ? s.slice(sepIdx + 1).replace(/[.,]/g, "").slice(0, 2) : "";
  intPart = intPart.replace(/^0+(?=\d)/, "");
  const intFmt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  const display = sepIdx >= 0 ? `${intFmt},${decPart}` : intFmt;
  const stored = sepIdx >= 0 ? `${intPart}.${decPart}` : intPart;
  return { display, stored };
};
